import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function SlackIcon(props) {
  const w = props.width || 60;
  const h = props.height || 60;
  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={props.style} {...props}>
      <Svg
        width={w}
        height={h}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M12.6059 37.9152C12.6059 41.3843 9.77199 44.2182 6.30293 44.2182C2.83388 44.2182 0 41.3843 0 37.9152C0 34.4462 2.83388 31.6123 6.30293 31.6123H12.6059V37.9152Z"
          fill="#E01E5A"
        />
        <Path
          d="M15.7817 37.9152C15.7817 34.4462 18.6156 31.6123 22.0847 31.6123C25.5537 31.6123 28.3876 34.4462 28.3876 37.9152V53.697C28.3876 57.166 25.5537 59.9999 22.0847 59.9999C18.6156 59.9999 15.7817 57.166 15.7817 53.697V37.9152Z"
          fill="#E01E5A"
        />
        <Path
          d="M22.0847 12.6059C18.6156 12.6059 15.7817 9.77199 15.7817 6.30293C15.7817 2.83388 18.6156 0 22.0847 0C25.5537 0 28.3876 2.83388 28.3876 6.30293V12.6059H22.0847Z"
          fill="#36C5F0"
        />
        <Path
          d="M22.0847 15.7822C25.5537 15.7822 28.3876 18.6161 28.3876 22.0852C28.3876 25.5542 25.5537 28.3881 22.0847 28.3881H6.30293C2.83388 28.3881 0 25.5542 0 22.0852C0 18.6161 2.83388 15.7822 6.30293 15.7822H22.0847Z"
          fill="#36C5F0"
        />
        <Path
          d="M47.394 22.0852C47.394 18.6161 50.2279 15.7822 53.697 15.7822C57.166 15.7822 59.9999 18.6161 59.9999 22.0852C59.9999 25.5542 57.166 28.3881 53.697 28.3881H47.394V22.0852Z"
          fill="#2EB67D"
        />
        <Path
          d="M44.2182 22.0847C44.2182 25.5537 41.3843 28.3876 37.9152 28.3876C34.4462 28.3876 31.6123 25.5537 31.6123 22.0847V6.30293C31.6123 2.83388 34.4462 0 37.9152 0C41.3843 0 44.2182 2.83388 44.2182 6.30293V22.0847Z"
          fill="#2EB67D"
        />
        <Path
          d="M37.9152 47.3945C41.3843 47.3945 44.2182 50.2284 44.2182 53.6975C44.2182 57.1665 41.3843 60.0004 37.9152 60.0004C34.4462 60.0004 31.6123 57.1665 31.6123 53.6975V47.3945H37.9152Z"
          fill="#ECB22E"
        />
        <Path
          d="M37.9152 44.2182C34.4462 44.2182 31.6123 41.3843 31.6123 37.9152C31.6123 34.4462 34.4462 31.6123 37.9152 31.6123H53.697C57.166 31.6123 59.9999 34.4462 59.9999 37.9152C59.9999 41.3843 57.166 44.2182 53.697 44.2182H37.9152Z"
          fill="#ECB22E"
        />
      </Svg>
    </TAG>
  );
}
